import React from 'react';
import _classNames from 'classnames';
import _get from 'lodash/get';
import { Button, makeStyles } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { setAuthModalState, storeItemForSignIn } from 'containers/Auth/actions';
import Mixpanel from 'utils/mixpanelService';

const useStyles = makeStyles({
  root: {
    padding: '10px 16px',
    alignSelf: 'flex-start',
    borderRadius: 8,
  },
});

export const SeriesSignUpButton = ({
  className,
  seriesSiteCopy,
  item,
  trackingPath,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const onSignUpStart = () => {
    dispatch(
      storeItemForSignIn({
        type: 'series',
        payload: {
          item,
        },
      }),
    );
    dispatch(setAuthModalState({ show: true, type: 'series' }));
    Mixpanel.track('Series - Sign Up CTA Clicked', {
      slug: _get(item, 'fields.slug'),
      name: _get(item, 'fields.title'),
      path: trackingPath,
    });
  };

  return (
    <Button
      className={_classNames(classes.root, className)}
      variant="outlined"
      color="primary"
      onClick={onSignUpStart}
    >
      {_get(seriesSiteCopy, 'pageCopy.signUpCTA')}
    </Button>
  );
};
